import React from "react";
import "./ChatLoader.module.css";

const ChatLoader = ({ isLoading, selectedChatId }) => {
    if (!isLoading) return null;

    return (
        <div className="chat-loader-overlay">
            <div className="chat-loader-container">
                <div className="chat-loader-spinner">
                    <div className="chat-loader-dot chat-loader-dot1"></div>
                    <div className="chat-loader-dot chat-loader-dot2"></div>
                    <div className="chat-loader-dot chat-loader-dot3"></div>
                </div>
                <p className="chat-loader-text">Loading chat...</p>
            </div>
        </div>
    );
};

export default ChatLoader;
